import classnames from 'classnames';
import { useIsIframe } from '../../../hooks/useIsIframe';
import Icon from '../icons/Icon';

import { useBasket } from '~/components/routes/campaign/useBasket';
import './support-footer.scss';

interface Props {
  displayHeading?: boolean;
  accommodateShoppingCart?: boolean;
  /** Defaults to "210 10 210" */
  phoneNumber?: string;
}

export const SupportFooter = ({ displayHeading = true, accommodateShoppingCart = false, phoneNumber = "210 10 210" }: Props) => {
  const isSummaryOpen = useBasket((s) => s.isSummaryOpen);

  const isIframe = useIsIframe();

  if (isIframe) {
    return null;
  }

  const classNames = classnames('support-footer', { 'accommodate-shopping-cart': accommodateShoppingCart });

  return (
    <footer className={classNames} aria-hidden={isSummaryOpen}>
      {displayHeading && (
        <h2 className="footer-title" tabIndex={-1}>
          Lurer du på noe?
        </h2>
      )}
      <ul>
        <li>
          <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} target="_blank" rel="noopener noreferrer">
            <Icon type="phone" size={1.5} />
            Ring oss på {phoneNumber}
          </a>
        </li>

        <li>
          <a
            href="https://www.rikstv.no/kontakt/chat/"
            target="_blank"
            rel="noopener noreferrer"
            data-track-id="footer-chat"
            data-track-link-name="Chat med oss"
          >
            <Icon type="message" size={1.5} /> Chat med oss
          </a>
        </li>

        <li>
          <a
            href="mailto:kundeservice@rikstv.no"
            target="_blank"
            rel="noopener noreferrer"
            data-track-id="footer-email"
            data-track-link-name="Send oss en e-post"
          >
            <Icon type="email" size={1.5} />
            Send oss en e-post
          </a>
        </li>
      </ul>
    </footer>
  );
};
